export default "__VITE_ASSET__DVG6gfG6__"